const ConnectionIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		{...props}
	>
		<path d="M11 15H6L13 1V9H18L11 23V15Z"/>
	</svg>
)

export default ConnectionIcon